import React from 'react';
import { Button, Tooltip } from 'antd';
import { DashboardPrimaryActionButton } from '../components/dashboard';
import { isOperatorUseBlocked, SERVICE_OVERDUE_MESSAGE } from './operatorDashboardUtils';

export default function OperatorForkliftActions({
  busy,
  forklift,
  layout = 'desktop',
  onSafetyReport,
  onStartChecklist,
}) {
  const blocked = isOperatorUseBlocked(forklift);
  const isMobile = layout === 'mobile';

  const stopAndRun = (event, callback) => {
    event.stopPropagation();
    callback(forklift);
  };

  return (
    <div className={`operator-forklift-actions operator-forklift-actions-${layout}`}>
      <Tooltip title={blocked ? SERVICE_OVERDUE_MESSAGE : ''}>
        <DashboardPrimaryActionButton
          block={isMobile}
          size="middle"
          onClick={(event) => stopAndRun(event, onStartChecklist)}
          disabled={busy || blocked}
          className={`operator-forklift-primary-action${isMobile ? ' operator-forklift-mobile-primary-action' : ''}`}
        >
          Start Checklist
        </DashboardPrimaryActionButton>
      </Tooltip>
      {blocked && (
        <Button
          block={isMobile}
          size="middle"
          onClick={(event) => stopAndRun(event, onSafetyReport)}
          disabled={busy}
          className="operator-forklift-secondary-action"
        >
          Report Safety Issue
        </Button>
      )}
    </div>
  );
}
